<template>
  <div class="layout-main">
    <div class="mod-hero" style="margin-top: -100px">
      <div class="cdc-carousel__item">
        <div class="cdc-carousel__item-inner">
          <div class="cdc-carousel__item-bg" style="
              /* background-image: url(https://qcloudimg.tencent-cloud.cn/raw/e21243f005aed04a2484c0d20659ae42.png); */
              background-color: #f1f5fa;
            "></div>
          <div class="cdc-carousel__item-content">
            <!-- <div class="cdc-carousel__item-title" style="display: none;">我的考试</div> -->
            <!-- <div class="cdc-carousel__item-desc">跨境电商学习平台</div> -->
            <div class="cdc-carousel__item-operate">
              <div class="cdc-carousel__item-search">
                <input class="search-input" v-model="listQuery.keywords" placeholder="请输入您想搜索的考试"
                  @keyup.13="queryExam" />
                <button class="cdc-btn search-btn" @click="queryExam">
                  搜索
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mod-selector">
      <div class="mod-selector__inner">
        <div class="mod-selector__item">
          <div class="mod-selector__item-inner">
            <div class="mod-selector__item-tags">
              <!-- <div class="mod-selector__item-tag is-selected">全部</div>
              <div class="mod-selector__item-tag">考试中</div>
              <div class="mod-selector__item-tag">待考试</div>
              <div class="mod-selector__item-tag">已考完</div> -->


              <div class="mod-selector__item-tag" :class="{ 'is-selected': listQuery.state === item.value }"
                v-for="item in stateOptions" @click="queryState(`${item.value}`)" :key="item.value">
                {{ item.text }}
              </div>
              <div class="mod-selector__item-tag" :class="{ 'is-selected': listQuery.state === '' }"
                @click="queryState('')">
                全部
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cdc-tech-video__main">
      <!-- <div class="mod-filter">
        <ul class="mod-filter__list">
          <li class="mod-filter__item is-selected">人气</li>
          <li class="mod-filter__item">最新发布</li>
        </ul>
        <div class="mod-filter__total">共找{{ total }}个课程</div>
      </div> -->

      <div class="mod-course">
        <div v-if="listData.length > 0" class="mod-course__list">
          <div class="item" v-for="(item, index) in listData" :key="index">
              <el-link :underline="false" @click="handleOpenExam(item)">
                <div class="section">
                  <div alt="考试封面" class="img" :style="{
                    height: '162px',
                    'background-image': `url(${fileUrl}/${item.cover})`,
                    'background-size': 'cover',
                    'background-color': '#efefef',
                  }"></div>
                  <div class="con">
                    <div class="info">
                      <h3 class="title">{{ item.name }}</h3>

                      <el-row>
                        <el-col :span="12">
                          <p>
                            <strong>开始时间: </strong>{{
                              new Date(item.startDate)
                              | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                            }}
                          </p>
                        </el-col>
                        <el-col :span="12">
                          <p>
                            <strong>结束时间: </strong>{{
                              new Date(item.endDate)
                              | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                            }}
                          </p>
                        </el-col>
                      </el-row>

                      <el-row>
                        <el-col :span="12">
                          <p>
                            <strong>考试时长: </strong>{{ bindCalculateTime(item.startDate, item.endDate) }}
                          </p>
                        </el-col>
                        <el-col :span="12">
                          <p>
                            <strong>提前进入: </strong>{{ item.advanceTime }}分钟
                          </p>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="24">
                          <p><strong>备注: </strong></p>
                        </el-col>
                      </el-row>
                    </div>
                    <div class="bottom">
                      <div class="state_con" style="display: flex; justify-content: space-between">
                        <span v-if="item.state === 1" class="progress">考试中</span>
                        <span v-if="item.state === 2" class="begin">待考试</span>
                        <span v-if="item.state === 3" class="completed">已考完</span>
                        <div style="position: absolute; right: 0; bottom: -4px">
                          <span v-if="item.achievementState === 1" style="color: #409eff; font-size: 14px">已交卷</span>
                          <span v-if="item.achievementState === 2" style="color: #409eff; font-size: 14px">评卷中</span>
                          <el-button v-if="item.achievementState === 3" size="mini" round
                            @click="handleOpenResults(item.achievementId)">查看试卷</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-link>
          </div>
        </div>
        <el-empty v-else :image-size="200" description="没有数据."></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { calculateTimeDifference } from "@/utils/index";
import { examPlanService, examAchievementService } from "@/api/exams";
export default {
  name: "List",
  components: {},
  data() {
    return {
      tableKey: 0,
      tableSize: "",
      listData: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: undefined,
        state: "2", // 默认为待考试
        sort: "state asc",
      },
      stateOptions: [],

      fileUrl: process.env.VUE_APP_FILE_URL,
    };
  },
  computed: {
    bindCalculateTime() {
      return (startTime, endTime) => {
        const diff = calculateTimeDifference(startTime, endTime);
        return `${diff.hours * 60 + diff.minutes}分钟${diff.seconds}秒`;
      };
    },
  },
  created() {
    this.getList();
    this.loadStateOptions();
  },
  methods: {
    loadStateOptions() {
      this.stateOptions =
        this.$store.getters["enums/getSysEnums"]("AchievementState");
    },
    getList() {
      this.listLoading = true;

      examPlanService
        .getPlanPageStudentList({
          name: this.listQuery.keywords,
          state: this.listQuery.state,
          sorting: this.listQuery.sort,
        })
        .then((res) => {
          this.listData = res.items.map((item) => {
            return Object.assign(item, {
              achievementId: undefined,
              achievementState: 1,
            });
          });
          this.total = res.totalCount;

          this.listLoading = false;

          // 延迟加载配置数据
          this.listData.forEach((item) => {
            // 成绩信息
            examAchievementService
              .getAchievementByPlanId(item.id)
              .then((achievement) => {
                if (res) {
                  item.achievementId = achievement.id;
                  item.achievementState = achievement.state;
                }
              });
          });
        });
    },
    // 搜索考试
    queryExam() {
      this.getList();
    },
    // 搜索状态
    queryState(value) {
      this.listQuery.state = value;
      this.getList();
    },

    handleOpenExam(row) {
      switch (row.state) {
        case 1:
          examAchievementService.getAchievementByPlanId(row.id).then((res) => {
            if (res) {
              this.$alert("已提交考卷, 不能再次进入。", "提示");
            } else {
              window.open(`/testing/${row.id}`, "_blank");
            }
          });
          break;
        case 2:
          this.$alert("考试暂未开始，请待考试开始后刷新页面进入", "提示");
          break;
        // case 3:
        //   window.open("/results/dfd0b696-80a3-c7dc-3125-3a13dc6e57f4", "_blank");
        //   break;
        default:
          break;
      }
    },
    handleBeginExam() {
      this.$alert("考试暂无开始，请待考试开始后刷新页面进入", "提示");
    },
    handleOpenResults(achievementId) {
      if (achievementId) {
        window.open(`/results/${achievementId}`, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.layout-main {
  margin: 0;
  padding: 0;
}

.layout-main .mod-hero {
  height: 220px;
}

.layout-main .mod-hero .cdc-carousel__item {
  width: 100%;
  height: 100%;
}

.cdc-carousel__item-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.cdc-carousel__item-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-position: top;
  background-size: auto 100%;
  background-repeat: no-repeat;
  overflow: hidden;
}

.cdc-carousel__item-content {
  box-sizing: border-box;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 152px 10px 10px;
  position: relative;
}

.cdc-carousel__item-desc,
.cdc-carousel__item-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.cdc-carousel__item-title {
  font-weight: 500;
  font-size: 36px;
  line-height: 44px;
  max-width: 480px;
  margin-bottom: 16px;
  color: #181818;
}

.cdc-carousel__item-desc {
  font-size: 16px;
  line-height: 24px;
  color: #4b5b76;
  max-width: 475px;
}

.cdc-carousel__item-operate {
  margin-top: 16px;
}

.cdc-carousel__item-search {
  width: 480px;
  height: 40px;
  background: #f4f4f5;
  /* border-radius: 30px; */
  padding: 2px 90px 2px 20px;
  box-sizing: border-box;
  position: relative;
}

.cdc-carousel__item-search .search-input {
  box-sizing: border-box;
  background: transparent;
  width: 100%;
  font-size: 14px;
  color: #181818;
  line-height: 36px;
  outline: none;
  border: none;
}

.cdc-carousel__item-search .search-btn {
  position: absolute;
  width: 81px;
  height: 40px;
  line-height: 34px;
  /* border-radius: 30px; */
  top: 2px;
  right: 2px;
  min-width: unset;
  margin-top: -2px;
}

.cdc-btn {
  height: 36px;
  min-width: 92px;
  padding: 0 16px;
  background-color: #e6a23c;
  border: 1px solid transparent;
  box-sizing: border-box;
  line-height: 34px;
  font-size: 14px;
  color: #fff;
  box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
  cursor: pointer;
  text-align: center;
}

.layout-main .mod-selector {
  box-sizing: border-box;
  padding: 28px 0 1px;
  /* background: linear-gradient(0deg, #f5f7fa -55.92%, #fff 93.75%); */
  background: linear-gradient(0deg, #f5d7aa -55.92%, #fff 93.75%);
}

.mod-selector__inner {}

.mod-selector__item {
  position: relative;
  max-height: 54px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 8px 0;
}

.mod-selector__item:last-child {
  margin-bottom: 27px;
}

.mod-selector__item-inner {
  display: flex;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 54px 0 10px;
  position: relative;
}

.mod-selector__item-label {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #181818;
  flex-shrink: 0;
  margin-right: 16px;
  padding-top: 8px;
}

.mod-selector__item-tags {
  flex: 1 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 -2px -8px;
}

.mod-selector__item-tag {
  cursor: pointer;
  box-sizing: border-box;
  padding: 8px 20px;
  position: relative;
  font-size: 14px;
  line-height: 22px;
  color: #4b5b76;
  margin: 0 2px 8px;

  background: #fff;
}

.mod-selector__item-tag.is-selected {
  background: #e6a23c;
  color: #fff;
}

.mod-selector__item-tag.is-selected:after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  border: 1px solid #e6a23c;
  border-radius: 2px;
}

.layout-main .cdc-tech-video__main {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 100px;
  box-sizing: border-box;
  /* padding: 0 10px; */
  min-height: calc(100vh - 320px - 530px - 140px);
}

.mod-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 36px auto 20px;
  font-size: 14px;
  line-height: 22px;
  color: #4b5b76;
}

.mod-filter__list {
  flex: 1 0 auto;
  display: flex;
  align-items: center;
}

li {
  list-style: none;
}

.mod-filter__item {
  margin-right: 42px;
  cursor: pointer;
}

.mod-filter__item.is-selected,
.cdc-tech-video-page .cdc-tech-video__main .mod-filter__item:hover {
  color: #e6a23c;
}

.mod-filter__total {
  flex-shrink: 1;
}

.mod-course {
  /* width: 1200px; */
  margin: 0 auto;
}

.mod-course .mod-course__list {
  min-height: 200px;
  /* overflow: hidden; */
  padding-top: 24px;

  display: flex;
  flex-wrap: wrap;
}

.mod-course .mod-course__list .item {
  cursor: pointer;
  float: left;
  margin: 0 20px 20px 0;
  border-radius: 8px;
  -webkit-transition: all ease-in 0.2s;
  -o-transition: all ease-in 0.2s;
  transition: all ease-in 0.2s;
  line-height: 0;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.1);
}

.mod-course .mod-course__list .item:nth-child(2n) {
  margin-right: 0;
}

.section {
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 580px;
  height: 288px;
  border-radius: 8px;
  background: #fff;
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 0;
  overflow: hidden;
  -webkit-transition: all ease-in 0.2s;
  -o-transition: all ease-in 0.2s;
  transition: all ease-in 0.2s;
}

.section .img {
  width: 100%;
  max-height: 162px;
  overflow: hidden;

  font-size: 20px;
  line-height: 162px;
  text-align: center;
  color: #999;
}

.section .con {
  position: relative;
  padding: 10px 12px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 126px;
  border-radius: 0 0 8px 8px;

  border-top: 1px dashed #e4e4e4;
}

.section .con .info {
  margin: 0;
  padding: 0;
  outline: none;

  height: 94px;
}

.section .con .info .title {
  max-height: 36px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  font-weight: bold;
  font-family: PingFangSC-Medium, PingFangSC;
  line-height: 18px;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.section .con .info p {
  height: 12px;
  line-height: 12px;
  font-size: 12px;
  margin-top: 6px;
  color: #666;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* .section .con .info span {
  position: absolute;
  bottom: 12px;
  right: 14px;
  display: inline-block;
  font-size: 12px;
  min-width: 50px;
  height: 12px;
  line-height: 12px;
  color: #999;
} */

.section .con .bottom {
  height: 20px;
  font-family: PingFangSC-Regular, PingFangSC;
}

.section .con .bottom .state_con {
  position: relative;
  text-align: left;
  top: -8px;
}

.section .con .bottom .state_con span {
  display: inline-block;
  color: #ff7a3e;
  font-size: 20px;
  height: 20px;
  line-height: 20px;
  font-weight: 600;
}

.section .con .bottom .state_con span.progress {
  color: #00cc7e;
}

.section .con .bottom .state_con span.begin {
  color: #f98c06;
}

.section .con .bottom .state_con span.completed {
  color: #c0c4cc;
}
</style>
